.h1{gap:0.25rem;}